/*******************************************************************************
 * Copyright     : Copyright (c)  2024 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc.No part may be reproduced or transmitted in any form by any
 *                 means or for anypurpose without the express written permission of Honeywell. *
 *******************************************************************************/
/**
 * This file contains the getErrorInfo function which returns error information based on status codes.
 *  */
import { LOCALE_CONST } from "../../utils/constants";

interface ErrorInfo {
  title: string;
  description: string;
}

export const getErrorInfo = (statusCode: number, convertFn: (val: string) => string): ErrorInfo => {
  const errorMessages: { [key: number]: ErrorInfo } = {
    400: {
      title: convertFn(LOCALE_CONST.badRequestText),
      description: convertFn(LOCALE_CONST.invalidReqInput)
    },
    401: {
      title: convertFn(LOCALE_CONST.unauthorized),
      description: convertFn(LOCALE_CONST.unauthAccess)
    },
    403: {
      title: convertFn(LOCALE_CONST.forbidden),
      description: convertFn(LOCALE_CONST.accessDenied)
    },
    404: {
      title: convertFn(LOCALE_CONST.notFound),
      description: convertFn(LOCALE_CONST.resourceNotFound)
    },
    500: {
      title: convertFn(LOCALE_CONST.internalServerErrorText),
      description: convertFn(LOCALE_CONST.serverErrorTryText)
    },
    502: {
      title: convertFn(LOCALE_CONST.badGateway),
      description: convertFn(LOCALE_CONST.badGatewayTry)
    },
    503: {
      title: convertFn(LOCALE_CONST.serviceUnavailable),
      description: convertFn(LOCALE_CONST.serviceUnavailableTry)
    },
    504: {
      title: convertFn(LOCALE_CONST.gatewayTimeout),
      description: convertFn(LOCALE_CONST.gatewayTimeoutTry)
    }
  };

  return (
    errorMessages[statusCode] || {
      title: convertFn(LOCALE_CONST.error),
      description: convertFn(LOCALE_CONST.reportAnErrOccurred)
    }
  );
};